<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ visualizar ? 'Detalhes setor' : isCadastro ? 'Cadastrar setor' : 'Alterar setor' }}</span>

    @if (!visualizar) {
      <form [formGroup]="formSetor" (ngSubmit)="salvar()">
        <div class="main-modal-lateral-edicao">
          @if(!isCadastro){
            <div class="flex-row justify-between">
              <app-slide-toggle-padrao [valor]="setor.ativo" (changeValue)="setor.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
            </div>
          }

          <app-form-field formControlName="nome" label="Nome" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>
          <app-form-field formControlName="descricao" label="Descrição" heightFormField="35px" (changeValue)="alteracaoService.camposAlterado()"></app-form-field>

          <app-select-multiple
            label="Plataformas de Bases dinâmicas"
            placeholder="Selecione"
            campo="nome"
            heightFormField="35px"
            backgroundColor="white"
            [listaInput]="plataformas"
            [itensSelecionado]="plataformasSelecionadas"
            [carregandoInfo]="carregandoPlataformas"
            (selecionarItem)="onSelecionarPlataformas($event)">
          </app-select-multiple>

          @for (plataforma of plataformasSelecionadas; track plataforma.id) {
            <div class="bloco-base-plataforma">
              <app-select-multiple
                [label]="'Bases dinâmicas de contato - ' + plataforma.nome"
                placeholder="Selecione"
                campo="id"
                subCampo="nome"
                heightFormField="35px"
                backgroundColor="white"
                [listaInput]="basesPorPlataforma[plataforma.id!] || []"
                [itensSelecionado]="basesSelecionadasPorPlataforma[plataforma.id!] || []"
                [carregandoInfo]="carregandoBasesPorPlataforma[plataforma.id!]"
                (selecionarItem)="onSelecionarBases(plataforma.id!, $event)">
              </app-select-multiple>

              @for (base of basesSelecionadasPorPlataforma[plataforma.id!]; track base.id) {
                <div class="linha-base">
                  <span class="font-12 nome-base" [matTooltip]="base.nome ?? ''" matTooltipPosition="above">{{ base.nome }}</span>
                  <mat-icon
                    class="icone-remover-base"
                    matTooltip="Remover base"
                    matTooltipPosition="left"
                    (click)="removerBase(plataforma.id!, base)">delete_forever</mat-icon>
                </div>
              }
            </div>
          }

        </div>
      </form>
    } @else {
      <div class="main-modal-lateral-info">
        <div class="container-info-modal-lateral">
          <span class="label">Nome</span>
          <span class="font-12 ellipse">{{setor.nome}}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Descrição</span>
          <span class="font-12 ellipse">{{setor.descricao}}</span>
        </div>

        @for (plataforma of plataformasSelecionadas; track plataforma.id) {
          <div class="container-info-modal-lateral">
            <span class="label">Bases dinâmicas de contato - {{ plataforma.nome }}</span>
            @for (base of basesSelecionadasPorPlataforma[plataforma.id!]; track base.id) {
              <span class="font-12 ellipse">{{ base.nome }}</span>
            } @empty {
              <span class="font-12 ellipse">-</span>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (!visualizar) {
    <div class="botoes-modal-lateral">
      <app-button-padrao
        width="100%"
        label="Salvar"
        [backgroundColor]="formSetor.invalid ? 'grey' : 'var(--verde-padrao)'"
        [color]="formSetor.invalid ? 'dark-grey' : 'white'"
        [type]="'submit'"
        [disabled]="formSetor.invalid"
        (buttonClick)="salvar()">
      </app-button-padrao>
      <app-button-padrao
        width="100%"
        label="Cancelar"
        backgroundColor="white"
        color="var(--vermelho-padrao)"
        (buttonClick)="cancelar()"
        borderColor="var(--vermelho-padrao)"
        borderStyle="solid"
        borderWidth="1px">
      </app-button-padrao>
    </div>
  }
</div>
